// import images from all-images/blog-img directory
import img01 from "../all-images/HR-AI.png";
import img02 from "../all-images/morale.png";
import img03 from "../all-images/corporate.png";
import img04 from "../all-images/techno.png";

const blogData = [
  {
    id: 1,
    title: "The Role of AI in Modern Recruitment Practices",
    imgUrl: img01,
    description:
      "Explain how AI tools streamline hiring by automating resume screening, conducting initial interviews, and reducing biases.",
       quote:
      "We are here to try and explain to you how to minimise the risks associated with driving while maximising the fun and opportunities to be had.",
  },

  {
    id: 2,
    title: "5 Proven Ways to Boost Employee Morale",
    imgUrl: img02,
    description:
      " Share tips such as offering recognition programs, promoting open communication, and organizing team-building activities. ",
    quote:
      "Share tips such as offering recognition programs, promoting open communication, and organizing team-building activities..",
 
  },

  {
    id: 3,
    title: "Top Trends in Corporate Training for 2025.",
    imgUrl: img03,
    description:
      " Cover trends like virtual reality training, bite-sized learning, and tailored development paths. ",
       quote:
      "Cover trends like virtual reality training, bite-sized learning, and tailored development paths.",
  },

  {
    id: 4,
    title: "Adapting to Technological Changes in the Workplace",
    imgUrl: img04,
    description:
      " Share tips on ensuring employees are equipped to handle rapid tech advancements through training and tools. ",
       quote:
      "Share tips on ensuring employees are equipped to handle rapid tech advancements through training and tools.",
  },
];

export default blogData;